import {getUser} from '../../auth/jwtAuth';
import {getAwpClientHeaders} from '../../session/awpRequestHeaders';

/** Prefer same-origin /api proxy in dev; fall back to explicit API URL. */
export const FIRESTORE_API_BASE =
    process.env.REACT_APP_AWP_API_BASE
    || process.env.REACT_APP_AWP_API_URL
    || '';

export function firestoreAuthHeaders(extra = {}) {
    const headers = {
        'Content-Type': 'application/json',
        ...getAwpClientHeaders(),
        ...extra,
    };
    const uid = getUser()?.uid || getUser()?.userId;
    if (uid) {
        headers['X-User-Id'] = uid;
    }
    return headers;
}

export async function firestoreApiFetch(path, opts = {}) {
    const resp = await fetch(`${FIRESTORE_API_BASE}${path}`, {
        ...opts,
        headers: firestoreAuthHeaders(opts.headers),
    });
    if (resp.status === 404) return null;
    if (!resp.ok) {
        let detail = `${opts.method || 'GET'} ${path} → ${resp.status}`;
        try {
            const body = await resp.json();
            if (body?.error) detail = body.error;
        } catch {
            /* ignore */
        }
        throw new Error(detail);
    }
    if (resp.status === 204) return null;
    return resp.json();
}
